/*
Monotype Foundry Platform API
Version 1.0.0

Definition: FoundryDetailResponse

Properties:
  address: object
  bipocOwned: string
  contractSummary: string
  credibility: string
  directory: string
  emailConsent: string
  externalId: string
  foundryDescription: array
  id: string
  images: array
  isFontDataInPIM: string
  lgbtqOwned: string
  name: string
  permissions: array
  pimContractSummary: string
  shortDescription: string
  status: string
  supportEmail: object
  updatedDate: string
  womenOwned: string
*/

var FoundryDetailResponse = (function () {
  function validateFoundryDetailResponse (arg) {
    // Validate address
    if (arg.address && !(typeof arg.address === 'object')) {
      throw new Error('FoundryDetailResponse.address: Wrong type: Got \'' + (typeof arg.address) + '\', but expected: \'object\'')
    }
    // Validate bipocOwned
    if (arg.bipocOwned && !(typeof arg.bipocOwned === 'string')) {
      throw new Error('FoundryDetailResponse.bipocOwned: Wrong type: Got \'' + (typeof arg.bipocOwned) + '\', but expected: \'string\'')
    }
    // Validate contractSummary
    if (arg.contractSummary && !(typeof arg.contractSummary === 'string')) {
      throw new Error('FoundryDetailResponse.contractSummary: Wrong type: Got \'' + (typeof arg.contractSummary) + '\', but expected: \'string\'')
    }
    // Validate credibility
    if (arg.credibility && !(typeof arg.credibility === 'string')) {
      throw new Error('FoundryDetailResponse.credibility: Wrong type: Got \'' + (typeof arg.credibility) + '\', but expected: \'string\'')
    }
    // Validate directory
    if (arg.directory && !(typeof arg.directory === 'string')) {
      throw new Error('FoundryDetailResponse.directory: Wrong type: Got \'' + (typeof arg.directory) + '\', but expected: \'string\'')
    }
    // Validate emailConsent
    if (arg.emailConsent && !(typeof arg.emailConsent === 'string')) {
      throw new Error('FoundryDetailResponse.emailConsent: Wrong type: Got \'' + (typeof arg.emailConsent) + '\', but expected: \'string\'')
    }
    // Validate externalId
    if (arg.externalId && !(typeof arg.externalId === 'string')) {
      throw new Error('FoundryDetailResponse.externalId: Wrong type: Got \'' + (typeof arg.externalId) + '\', but expected: \'string\'')
    }
    // Validate foundryDescription
    if (arg.foundryDescription && !(Array.isArray(arg.foundryDescription))) {
      throw new Error('FoundryDetailResponse.foundryDescription: Wrong type: Got \'' + (typeof arg.foundryDescription) + '\', but expected: \'array\'')
    }
    // Validate id
    if (arg.id && !(typeof arg.id === 'string')) {
      throw new Error('FoundryDetailResponse.id: Wrong type: Got \'' + (typeof arg.id) + '\', but expected: \'string\'')
    }
    // Validate images
    if (arg.images && !(Array.isArray(arg.images))) {
      throw new Error('FoundryDetailResponse.images: Wrong type: Got \'' + (typeof arg.images) + '\', but expected: \'array\'')
    }
    // Validate isFontDataInPIM
    if (arg.isFontDataInPIM && !(typeof arg.isFontDataInPIM === 'string')) {
      throw new Error('FoundryDetailResponse.isFontDataInPIM: Wrong type: Got \'' + (typeof arg.isFontDataInPIM) + '\', but expected: \'string\'')
    }
    // Validate lgbtqOwned
    if (arg.lgbtqOwned && !(typeof arg.lgbtqOwned === 'string')) {
      throw new Error('FoundryDetailResponse.lgbtqOwned: Wrong type: Got \'' + (typeof arg.lgbtqOwned) + '\', but expected: \'string\'')
    }
    // Validate name
    if (arg.name && !(typeof arg.name === 'string')) {
      throw new Error('FoundryDetailResponse.name: Wrong type: Got \'' + (typeof arg.name) + '\', but expected: \'string\'')
    }
    // Validate permissions
    if (arg.permissions && !(Array.isArray(arg.permissions))) {
      throw new Error('FoundryDetailResponse.permissions: Wrong type: Got \'' + (typeof arg.permissions) + '\', but expected: \'array\'')
    }
    // Validate pimContractSummary
    if (arg.pimContractSummary && !(typeof arg.pimContractSummary === 'string')) {
      throw new Error('FoundryDetailResponse.pimContractSummary: Wrong type: Got \'' + (typeof arg.pimContractSummary) + '\', but expected: \'string\'')
    }
    // Validate shortDescription
    if (arg.shortDescription && !(typeof arg.shortDescription === 'string')) {
      throw new Error('FoundryDetailResponse.shortDescription: Wrong type: Got \'' + (typeof arg.shortDescription) + '\', but expected: \'string\'')
    }
    // Validate status
    if (arg.status && !(typeof arg.status === 'string')) {
      throw new Error('FoundryDetailResponse.status: Wrong type: Got \'' + (typeof arg.status) + '\', but expected: \'string\'')
    }
    // Validate supportEmail
    if (arg.supportEmail && !(typeof arg.supportEmail === 'object')) {
      throw new Error('FoundryDetailResponse.supportEmail: Wrong type: Got \'' + (typeof arg.supportEmail) + '\', but expected: \'object\'')
    }
    // Validate updatedDate
    if (arg.updatedDate && !(typeof arg.updatedDate === 'string')) {
      throw new Error('FoundryDetailResponse.updatedDate: Wrong type: Got \'' + (typeof arg.updatedDate) + '\', but expected: \'string\'')
    }
    // Validate womenOwned
    if (arg.womenOwned && !(typeof arg.womenOwned === 'string')) {
      throw new Error('FoundryDetailResponse.womenOwned: Wrong type: Got \'' + (typeof arg.womenOwned) + '\', but expected: \'string\'')
    }
  }
  function buildFoundryDetailResponse (arg) {
    var FoundryDetailResponse = arg
    // Complete address
    // Expected Type: object
    FoundryDetailResponse.address = FoundryDetailResponse.address || {}
    // Complete address.address1
    // Expected Type: string
    FoundryDetailResponse.address.address1 = FoundryDetailResponse.address.address1 || ''
    // Complete address.address2
    // Expected Type: string
    FoundryDetailResponse.address.address2 = FoundryDetailResponse.address.address2 || ''
    // Complete address.addressIsPublic
    // Expected Type: string
    FoundryDetailResponse.address.addressIsPublic = FoundryDetailResponse.address.addressIsPublic || ''
    // Complete address.city
    // Expected Type: string
    FoundryDetailResponse.address.city = FoundryDetailResponse.address.city || ''
    // Complete address.contactName
    // Expected Type: string
    FoundryDetailResponse.address.contactName = FoundryDetailResponse.address.contactName || ''
    // Complete address.country
    // Expected Type: string
    FoundryDetailResponse.address.country = FoundryDetailResponse.address.country || ''
    // Complete address.headOfficeCountry
    // Expected Type: string
    FoundryDetailResponse.address.headOfficeCountry = FoundryDetailResponse.address.headOfficeCountry || ''
    // Complete address.headOfficeState
    // Expected Type: string
    FoundryDetailResponse.address.headOfficeState = FoundryDetailResponse.address.headOfficeState || ''
    // Complete address.state
    // Expected Type: string
    FoundryDetailResponse.address.state = FoundryDetailResponse.address.state || ''
    // Complete address.telephone
    // Expected Type: string
    FoundryDetailResponse.address.telephone = FoundryDetailResponse.address.telephone || ''
    // Complete address.website
    // Expected Type: string
    FoundryDetailResponse.address.website = FoundryDetailResponse.address.website || ''
    // Complete address.zipCode
    // Expected Type: string
    FoundryDetailResponse.address.zipCode = FoundryDetailResponse.address.zipCode || ''
    // Complete bipocOwned
    // Expected Type: string
    FoundryDetailResponse.bipocOwned = FoundryDetailResponse.bipocOwned || ''
    // Complete contractSummary
    // Expected Type: string
    FoundryDetailResponse.contractSummary = FoundryDetailResponse.contractSummary || ''
    // Complete credibility
    // Expected Type: string
    FoundryDetailResponse.credibility = FoundryDetailResponse.credibility || ''
    // Complete directory
    // Expected Type: string
    FoundryDetailResponse.directory = FoundryDetailResponse.directory || ''
    // Complete emailConsent
    // Expected Type: string
    FoundryDetailResponse.emailConsent = FoundryDetailResponse.emailConsent || ''
    // Complete externalId
    // Expected Type: string
    FoundryDetailResponse.externalId = FoundryDetailResponse.externalId || ''
    // Complete foundryDescription
    // Expected Type: array
    FoundryDetailResponse.foundryDescription = FoundryDetailResponse.foundryDescription || []
    // Complete id
    // Expected Type: string
    FoundryDetailResponse.id = FoundryDetailResponse.id || ''
    // Complete images
    // Expected Type: array
    FoundryDetailResponse.images = FoundryDetailResponse.images || []
    // Complete isFontDataInPIM
    // Expected Type: string
    FoundryDetailResponse.isFontDataInPIM = FoundryDetailResponse.isFontDataInPIM || ''
    // Complete lgbtqOwned
    // Expected Type: string
    FoundryDetailResponse.lgbtqOwned = FoundryDetailResponse.lgbtqOwned || ''
    // Complete name
    // Expected Type: string
    FoundryDetailResponse.name = FoundryDetailResponse.name || ''
    // Complete permissions
    // Expected Type: array
    FoundryDetailResponse.permissions = FoundryDetailResponse.permissions || []
    // Complete pimContractSummary
    // Expected Type: string
    FoundryDetailResponse.pimContractSummary = FoundryDetailResponse.pimContractSummary || ''
    // Complete shortDescription
    // Expected Type: string
    FoundryDetailResponse.shortDescription = FoundryDetailResponse.shortDescription || ''
    // Complete status
    // Expected Type: string
    FoundryDetailResponse.status = FoundryDetailResponse.status || ''
    // Complete supportEmail
    // Expected Type: object
    FoundryDetailResponse.supportEmail = FoundryDetailResponse.supportEmail || {}
    // Complete supportEmail.contactName
    // Expected Type: string
    FoundryDetailResponse.supportEmail.contactName = FoundryDetailResponse.supportEmail.contactName || ''
    // Complete supportEmail.emailAddress
    // Expected Type: string
    FoundryDetailResponse.supportEmail.emailAddress = FoundryDetailResponse.supportEmail.emailAddress || ''
    // Complete updatedDate
    // Expected Type: string
    FoundryDetailResponse.updatedDate = FoundryDetailResponse.updatedDate || ''
    // Complete womenOwned
    // Expected Type: string
    FoundryDetailResponse.womenOwned = FoundryDetailResponse.womenOwned || ''
    return FoundryDetailResponse
  }
  return {
    validate: validateFoundryDetailResponse,
    build: buildFoundryDetailResponse
  }
})()

module.exports = FoundryDetailResponse
